import * as React from "react";
import { Command } from "~/components/ui/command";
import { cn } from "~/lib/utils";

interface FilteredCommandProps extends React.ComponentPropsWithoutRef<
  typeof Command
> {}

export const FilteredCommand = React.forwardRef<
  React.ElementRef<typeof Command>,
  FilteredCommandProps
>(({ className, ...props }, ref) => {
  return (
    <Command
      ref={ref}
      className={cn(
        "flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground",
        className
      )}
      filter={(_, search, keywords = []) => {
        const extendValue = keywords.join(" ");
        return extendValue.toLowerCase().includes(search.toLowerCase()) ? 1 : 0;
      }}
      {...props}
    />
  );
});

FilteredCommand.displayName = "FilteredCommand";
